/* eslint-disable tailwindcss/no-custom-classname */
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { TermHead } from "@/components/organisms/TermHead";
import TermNav from "@/components/organisms/TermNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";

const textBody = [
  {
    head: "JavaScriptについて",
    body: "本サイトは、ユーザーさまの利便性向上のため「JavaScript」を使用しております。お使いのブラウザの設定でJavaScriptを OFFに設定した場合、ページによっては正常に動作しないことがございます。ホームページの基本的な閲覧障害となるものではありませんが、快適にホームページを閲覧していただくために、お使いのブラウザのJavaScriptの設定はON(有効)としていただくことをおすすめいたします。",
    sub: "",
  },
  {
    head: "Cookie（クッキー）について",
    body: "本サイトでは、Cookie（クッキー）を使用しております。Cookieは画面間の情報引継ぎを管理し、同一人であることを確認することにより不正アクセスを防止、セキュリティを確保することを目的にしています。但し、Cookieには個人情報は一切書き込まれません。",
    sub: "CookieがOFF（無効）になっている場合、ページによっては正常に動作しないことがございますので、ご利用にあたっては、Cookieの設定をON（有効）にしていただくようお願い致します。",
  },
  {
    head: "免責事項",
    body: "本サイトに掲載されるコンテンツは、無保証で提供されるサービスであり、その閲覧及びご利用はご利用者自身の責任において行うようお願いいたします。掲載内容についてはできるだけ正確であるよう努めておりますが、誤植・誤情報が掲載される場合や充分な情報を提供できない場合もあり、本サイトのコンテンツを閲覧及びご利用することによって生じたいかなる損害についても、当社は責任を負いません。また、掲載内容は予告なく変更される場合がありますので、あらかじめご了承ください。",
    sub: "",
  },
  {
    head: "著作権について",
    body: "本サイトに掲載されているコンテンツの著作権は、株式会社トッカシステムズが保有しております。本サイト上の全ての著作物（画像・文章・デザイン等）は、株式会社トッカシステムズの許可無く、複製・改ざん・再配布することはできません。",
    sub: "",
  },
];

export default function TermsPage(props) {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"サイトのご利用について"}
        pageDescription={
          "株式会社トッカシステムズのサイトのご利用についてです。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/terms/"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <Inner className="mx-auto box-border flex max-w-6xl flex-col py-10 px-6 text-pri sm:px-8 md:px-12 md:pt-16 md:pb-24">
              <TermNav />
              <div className="order-1 md:order-2">
                <TermHead>サイトのご利用について</TermHead>
                <div className="grid-rows-8 grid space-y-2 divide-y divide-x-0 divide-solid divide-bdc-light text-base text-txt-base md:space-y-2">
                  {textBody.map((textBody) => (
                    <dl
                      key={textBody.head}
                      className="
                      grid
                      grid-flow-dense
                      grid-cols-none
                      pt-2
                      first:pt-0
                      md:grid-flow-col
                      md:grid-cols-3
                      md:gap-12"
                    >
                      <dt className="col-auto inline-block font-bold leading-8 text-pri md:col-span-1 md:text-txt-light">
                        <div
                          dangerouslySetInnerHTML={{ __html: textBody.head }}
                        />
                      </dt>
                      <dd className="col-auto	leading-8 md:col-span-2">
                        {parse(textBody.body)}
                        {textBody.sub ? (
                          <p className="col-auto my-2 border border-solid border-bdc-accent py-3 px-4 text-sm text-txt-light md:col-span-2">
                            {parse(textBody.sub)}
                          </p>
                        ) : (
                          ""
                        )}
                      </dd>
                    </dl>
                  ))}
                </div>
              </div>
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
